import React from 'react';
import '../styles/LawLogin.css';
import { Link } from 'react-router-dom';
const LawLogin = () => {
  return (
    <div className="law-login-container">
 <Link to="/law-register" className="top-register-button">
  Register
</Link>

      <div className="law-login-card">
        <h2>Law Service Login</h2>
        <form>
          <input type="text" placeholder="Username" name="username" required />
          <input type="password" placeholder="Password" name="password" required />
          <button type="submit">Login</button>
        </form>
        <p className="law-login-footer-text">
          Forgot your password?{' '}
          <a href="/reset-password">Reset here</a>
        </p>
      </div>
    </div>
  );
};

export default LawLogin;
